import { render, staticRenderFns } from "./AudioInput.vue?vue&type=template&id=2b43c402&scoped=true&"
import script from "./AudioInput.vue?vue&type=script&lang=js&"
export * from "./AudioInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b43c402",
  null
  
)

export default component.exports